import React from "react";
import BaseView from "../common/BaseView";
import { columns } from "./config";
import { getAll } from "../../../Api";
import withData from "../../Data/withData";

function View(props: any) {
  return (
    <BaseView
      columns={columns}
      title="All"
      subtitle="This is a list of all companies submitted by you."
      {...props}
    ></BaseView>
  );
}

export default withData(View, getAll);
